<template>
	<div class="offers-container" v-if="hasCouponOffers()">
		<div class="offer-emoji">
			🎊
		</div>
		<div class="offer-message">
			{{ customerName }}, {{offerCouponMessage}}
		</div>
		<div v-for="(offer, index) in getCouponOffers()" :key="offerKey(offer, index)" class="offer-wrapper">
			<offer-coupon-item :offer="offer"/>
		</div>
	</div>
</template>

<script>
	import offersMixin from '@Mixin/offersMixin';
	import profileMixin from '@Mixin/profileMixin';
	import OfferCouponItem from '@/components/checkout/OfferCouponItem.vue';

	export default {
		mixins: [offersMixin, profileMixin],
		components: {
			'offer-coupon-item': OfferCouponItem,
		},
		computed: {
			offerCouponMessage() {
				const message = `we have some coupons just for you!`;
				return message;
			}
		},
		methods: {
			offerKey(offer, index) {
				return `${offer.uniqueKey}-${index}`;
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	@import 'commonStyle/offers';
</style>



// WEBPACK FOOTER //
// src/components/checkout/OfferCoupons.vue